import { FieldType } from "../../../../utils/dynamic-form/form.type";

interface IProductHeader {
  id: string;
  value: string;
  width?: string;
  sortColumn?: string;
  type?: string;
}
export class ProductHelper {
  public static readonly productSellerHeaders: IProductHeader[] = [
    {
      id: 'product',
      value: 'table.product',
      width: '7%',
      sortColumn: 'status'
    },
    {
      id: 'label',
      value: 'table.label',
      width: '20%'
    },
    {
      id: 'category',
      value: 'table.category',
      width: '19%'
    },
    {
      id: 'editorialCharter',
      value: 'table.editChart',
      sortColumn: 'editorialCharter.status',
      width: '10%'
    },
    {
      id: 'format',
      value: 'Format',
      width: '8%'
    },
    {
      id: 'brand',
      value: 'table.brand',
      width: '10%'
    },
    {
      id: 'ean',
      value: 'EAN',
      width: '10%'
    },
    {
      id: 'sku',
      value: 'SKU',
      width: '5%'
    },
    {
      id: 'lastUpdate',
      value: 'table.lastUpdate',
      type: 'date',
      width: '10%'
    },
    {
      id: 'creationDate',
      value: 'table.creationDate',
      type: 'date',
      width: '10%'
    },
  ];

  public static readonly productOperatorHeaders: IProductHeader[] = [...ProductHelper.productSellerHeaders,
    {
      id: 'seller',
      value: 'table.seller',
    },
  ];


  public static readonly searchFilters = [
    {
      label: 'catalog.distributionChannel',
      selectedItemPrefix: true,
      value: '',
      enbeddedLabel: true,
      name: 'channel',
      type: FieldType.select,
      options: [],
      optionLabel: 'channelName',
    },
    {
      label: 'catalog.searchText',
      type: FieldType.input,
      placeholder: 'catalog.searchText',
      name: 'search',
      iconPrefix: 'pi pi-search',
    },
    {
      label: 'global.filter',
      type: FieldType.button,
      subType: 'outlined',
      name: 'filter',
      iconPrefix: 'pi pi-filter',
      width: '120px',
      action: 'dialog',
      classes: 'right',
    },
  ];

}